import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, TextButton, useDevice } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { CurlyBracesIcon } from '../CurlyBracesIcon';
import styles from './VariableInsertButton.module.scss';
export const GetVariableInsertButtonTID = (parentTestId)=>getTestIds(parentTestId);
export function VariableInsertButton(param) {
    let { onClick, disabled, testId } = param;
    const { VariableInsertButtonTestIds } = useMemo(()=>GetVariableInsertButtonTID(testId), [
        testId
    ]);
    const { isMobileDevice } = useDevice();
    const { t } = useLocaleKeys('components.templateVariables');
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.variableInsertButtonWrapper,
        children: /*#__PURE__*/ _jsx(TextButton, {
            bi: {
                name: 'open_variable_picker'
            },
            suffixIcon: /*#__PURE__*/ _jsx(CurlyBracesIcon, {
                className: styles.bracesIcon
            }),
            underline: "none",
            weight: "normal",
            skin: "primary",
            disabled: disabled,
            onClick: onClick,
            testId: VariableInsertButtonTestIds.Root(),
            children: !isMobileDevice && t.insertButton()
        })
    });
}
